import ExpandMoreIcon from "@mui/icons-material/ArrowDropDown";
import ChevronRightIcon from "@mui/icons-material/ArrowDropUp";
import CreateFolderIcon from "@mui/icons-material/CreateNewFolder";
import DeleteIcon from "@mui/icons-material/Delete";
import WorkspaceIcon from "@mui/icons-material/DesktopWindows";
import RenameIcon from "@mui/icons-material/Edit";
import FolderIcon from "@mui/icons-material/Folder";
import GroupIcon from "@mui/icons-material/Group";
import ImportDocumentIcon from "@mui/icons-material/NoteAdd";
import SettingsIcon from "@mui/icons-material/Settings";
import Divider from "@mui/material/Divider";
import ListItemIcon from "@mui/material/ListItemIcon";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { styled } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import { TreeItem, SimpleTreeView } from "@mui/x-tree-view";
import classNames from "classnames";
import React, { useState, useEffect } from "react";

import {
  DOCUMENT,
  NEW,
  FOLDER,
  DELETE,
  EDIT,
  IS_ADMIN,
  CONFIGURE_PROCESS,
} from "../../constants/modules";
import useListPermission from "../../hooks/useListPermission";
import { language } from "../../language";

const Label = styled("div")(({ theme }) => ({
  fontWeight: "inherit",
  color: "inherit",
}));

const LabelRoot = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  padding: theme.spacing(0.5, 0),
}));

const LabelIcon = styled("div")(({ theme }) => ({
  marginRight: theme.spacing(1),
}));

const Icons = styled("div")(({ theme }) => ({
  fontSize: 26,
  color: "rgba(0, 0, 0, 0.54)",
}));

const LabelText = styled("div")(({ theme }) => ({
  fontWeight: "inherit",
  flexGrow: 1,
}));

const Content = styled("div")(({ theme }) => ({
  borderTopRightRadius: theme.spacing(2),
  borderBottomRightRadius: theme.spacing(2),
  paddingRight: theme.spacing(1),
  fontWeight: theme.typography.fontWeightMedium,
}));

export default function FolderSystemNavigation(props) {
  const [stateHighlighted, setstateHighlighted] = useState(false);
  const [loadList, setLoadList] = useState({
    list: [],
    highlighted: null,
    expanded: [],
  });

  // Permissoes
  const hasImportDocumentPermission = useListPermission(
    DOCUMENT + NEW,
  ).hasPermission;
  const hasDeleteFolderPermission = useListPermission(
    FOLDER + DELETE,
  ).hasPermission;
  const hasNewFolderPermission = useListPermission(FOLDER + NEW).hasPermission;
  const hasEditFolderPermission = useListPermission(
    FOLDER + CONFIGURE_PROCESS,
  ).hasPermission;
  const hasConfigureProcessFolderPermission = useListPermission(
    FOLDER + EDIT,
  ).hasPermission;

  const isAdmin = useListPermission(IS_ADMIN).hasPermission;

  const {
    tree,
    expanded,
    setexpanded,
    highlighted,
    onNodeSelect,
    disableContextMenu,
    fetchTreeSetData,
    openFirst,
  } = props;
  useEffect(() => {
    if (loadList.list.length > 0) {
      setTimeout(function () {
        const e = loadList.list;
        const n = e.pop();
        const nds = expanded;
        nds.unshift(n);
        fetchTreeSetData({ tree, id: n, nodes: nds });
        setLoadList({
          list: e,
          highlighted: loadList.highlighted,
          expanded,
        });
      }, 1000);
    } else if (loadList.highlighted !== null) {
      setstateHighlighted(loadList.highlighted);
      setLoadList({
        list: loadList.list,
        highlighted: null,
        expanded,
      });
    }
  }, [loadList, fetchTreeSetData, expanded, tree]);
  const updateLoadList = () => {
    if (loadList.list.length > 0) {
      const l = loadList.list;
      l.pop();
      setLoadList({
        list: l,
        highlighted: loadList.highlighted,
        expanded,
      });
    }
  };

  const handleChange = (event, nodes) => {
    updateLoadList();
    const expandingNodes = nodes.filter((x) => !expanded.includes(x));
    if (expandingNodes[0]) {
      const nodeId = nodes[0];
      fetchTreeSetData({ tree, id: nodeId, nodes });
    } else {
      setexpanded(nodes);
    }
  };

  useEffect(() => {
    if (tree && expanded && expanded[expanded.length - 1] === "l") {
      const e = expanded;
      e.pop();
      const h = e.pop();
      e.sort();
      setexpanded([]);
      setLoadList({ list: e.reverse(), highlighted: h, expanded: undefined });
    } else if (tree && openFirst && (!expanded || expanded.length === 0)) {
      handleChange(undefined, [tree[0].code]);
    }
  }, [tree, setLoadList, openFirst, expanded, setexpanded]); // TODO rever esse trecho

  useEffect(() => {
    setstateHighlighted(highlighted);
  }, [highlighted, setstateHighlighted]);

  const initialState = {
    mouseX: null,
    mouseY: null,
    data: null,
  };

  const [contextState, setcontextState] = useState(initialState);
  const [expandedValue, setExpandedValue] = useState(false);

  const handleClick = (event, data) => {
    event.preventDefault();

    setcontextState({
      mouseX: event.clientX - 2,
      mouseY: event.clientY - 4,
      data,
    });

    event.stopPropagation();
  };

  const handleClose = (event) => {
    if (event !== undefined) {
      event.preventDefault();

      setcontextState(initialState);

      event.stopPropagation();
    }
  };

  function renderTree(nodes) {
    const isWorkspace =
      nodes.documentType && nodes.documentType.name === "Workspace";

    if (nodes && nodes.id) {
      return (
        <TreeItem
          classes={{
            content: classes.content,
            root: classes.root,
          }}
          key={nodes.name}
          nodeId={String(nodes.id)}
          label={
            <div
              className={classes.labelRoot}
              onContextMenu={
                !disableContextMenu ? (e) => handleClick(e, nodes) : undefined
              }
            >
              {isWorkspace ? (
                <WorkspaceIcon
                  className={classNames(classes.labelIcon, classes.icons)}
                />
              ) : (
                <FolderIcon
                  className={classNames(classes.labelIcon, classes.icons)}
                />
              )}
              <Typography variant="body1" className={classes.labelText}>
                {nodes.name}
              </Typography>
            </div>
          }
        >
          {Array.isArray(nodes.children)
            ? nodes.children.map((node) => renderTree(node))
            : null}
        </TreeItem>
      );
    }
  }

  const contextStateIsWorkspace =
    contextState &&
    contextState.data &&
    contextState.data.documentType.name === "Workspace";

  const [dialogOpen, setDialogOpen] = useState(false);

  return (
    <>
      <SimpleTreeView
        defaultCollapseIcon={<ExpandMoreIcon />}
        defaultExpandIcon={<ChevronRightIcon />}
        selected={stateHighlighted}
        onNodeSelect={(e, node) => onNodeSelect(e, node)}
        onNodeToggle={(e, node) => handleChange(e, node)}
      >
        {tree &&
          tree.map((node) => {
            return renderTree(node);
          })}
      </SimpleTreeView>
      {contextState.mouseY !== null && (
        <Menu
          keepMounted
          open={contextState.mouseY !== null}
          onClose={handleClose}
          onContextMenu={handleClose}
          anchorReference="anchorPosition"
          anchorPosition={
            contextState.mouseY !== null && contextState.mouseX !== null
              ? { top: contextState.mouseY, left: contextState.mouseX }
              : undefined
          }
        >
          {hasNewFolderPermission && (
            <MenuItem>
              <ListItemIcon>
                <CreateFolderIcon />
              </ListItemIcon>
              <Typography variant="inherit">{language.NewFolder}</Typography>
            </MenuItem>
          )}

          <Divider />

          {hasEditFolderPermission &&
            contextState.data.documentType.name === "Workspace" && (
              <MenuItem>
                <ListItemIcon>
                  <GroupIcon />
                </ListItemIcon>
                <Typography variant="inherit">
                  {language.manageAccess}
                </Typography>
              </MenuItem>
            )}

          {hasEditFolderPermission && (
            <MenuItem
              onClick={(e) => {
                handleClose(e);
              }}
            >
              <ListItemIcon>
                <RenameIcon />
              </ListItemIcon>
              <Typography variant="inherit">{language.Rename}</Typography>
            </MenuItem>
          )}

          {!contextStateIsWorkspace && hasDeleteFolderPermission && (
            <MenuItem
              onClick={(e) => {
                handleClose(e);
              }}
            >
              <ListItemIcon>
                <DeleteIcon />
              </ListItemIcon>
              <Typography variant="inherit">{language.Delete}</Typography>
            </MenuItem>
          )}

          {isAdmin && contextState.data.documentType.name === "Workspace" && (
            <MenuItem
              onClick={(e) => {
                handleClose(e);
              }}
            >
              <ListItemIcon>
                <DeleteIcon />
              </ListItemIcon>
              <Typography variant="inherit">{language.Delete}</Typography>
            </MenuItem>
          )}

          {hasConfigureProcessFolderPermission &&
            contextState.data.documentType.name !== "Workspace" && (
              <MenuItem
                onClick={(e) => {
                  handleClose(e);
                }}
              >
                <ListItemIcon>
                  <SettingsIcon />
                </ListItemIcon>
                <Typography variant="inherit">
                  {language.ConfigureAutomaticProcessesOptionMenuFolder}
                </Typography>
              </MenuItem>
            )}

          {!contextStateIsWorkspace && (
            <div>
              <Divider />

              {hasImportDocumentPermission && (
                <MenuItem
                  onClick={(e) => {
                    handleClose(e);
                  }}
                >
                  <ListItemIcon>
                    <ImportDocumentIcon />
                  </ListItemIcon>
                  <Typography variant="inherit">
                    {" "}
                    {language.ImportDocument}{" "}
                  </Typography>
                </MenuItem>
              )}
            </div>
          )}
        </Menu>
      )}
    </>
  );
}
